import React from "react"
import styled from "styled-components"

import { Element, ElementProps } from "legacy/components/shared/base"

interface OwnProps {
  children?: React.ReactChild | React.ReactChild[]
}

export type StyledListItemProps = ElementProps & OwnProps

const StyledListItem = styled(Element)`
  list-style-type: disc;
`

const ListItem: React.FC<StyledListItemProps> = ({
  children,
}): React.ReactElement => {
  return <StyledListItem as="li">{children}</StyledListItem>
}

export default ListItem
